import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { withPrivate } from './Private'
import { Redirect, Route } from 'react-router-dom'
import * as R from 'ramda' 

import { enhance as withAnyRoles } from 'containers/Role/Hide/AnyGlobalRoles'
import LoginRedirect from './utils'

const RedirectToAlternate = (props) => {
  if(props.redirectTo){
    return (
      <Redirect
        to={{
          pathname: props.redirectTo,
          state: { from: props.location }
        }}
      />
    )
  }
  return LoginRedirect()
}

const enhance = R.curryN(2, compose(
  withPrivate,
  withAnyRoles
))

export default enhance(RedirectToAlternate)(Route)
